import { configureStore, isRejected, Middleware } from "@reduxjs/toolkit";
import { notification } from "antd";
import BancaReducer from "./Banca.reducer";
import MateriasReducer from "./Materias.reducer";
import QuestoesReducer from "./Questoes.reducer";
import CertameReducer from "./Certame.reducer";
import ProductReducer from "./Product.reducer";
import ResolucaoReducer from "./Resolucao.reducer";
import UsuarioReducer from "./Usuario.reducer";
import AssinanteReducer from "./Assinante.reducer";

/**
 * O RTK serializa o erro do thunk, então `action.error` perde o `response` e
 * `readApiError` não funciona aqui — sobra a mensagem do axios. Reconhecer o
 * status pelo texto é suficiente para o objetivo: quando a falha é negativa
 * de permissão, o interceptor (`app/auth/httpConfig.ts`) já mostrou o aviso
 * bonito, e este toast só empilharia "Request failed with status code 403" em
 * cima dele.
 */
const DENIAL_STATUS = /status code (401|403|429)/;

const observeActions: Middleware = () => (next) => (action) => {
  if (isRejected(action)) {
    const message = action.payload ? (action.payload as string) : action.error.message;

    if (!message || !DENIAL_STATUS.test(message)) {
      notification.error({ message });
    }
  }

  next(action);
};

export const store = configureStore({
  reducer: {
    banca: BancaReducer,
    materias: MateriasReducer,
    questoes: QuestoesReducer,
    certame: CertameReducer,
    product: ProductReducer,
    resolucao: ResolucaoReducer,
    usuario: UsuarioReducer,
    assinante: AssinanteReducer,
  },
  middleware: function (getDefaultMiddlewares) {
    return getDefaultMiddlewares().concat(observeActions);
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
